import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from "../Common/Axios/axiosInstance";
export const translationApi = async ( ) => {
    const { data = {} } = await axiosInstance.get(API.translationApi, {
      headers: {
        ...axiosInstance.defaults.headers,
       Userid: process.env.REACT_APP_USER_Name,
        Password: process.env.REACT_APP_USER_PASSWORD
      },
    })
  return data;  
};
